import React from "react";
import { useState } from 'react';
import { Helmet } from "react-helmet";
import { NavLink } from 'react-router-dom';


function FX(props)
{
    const [isVerified, setIsVerified] = useState(false);
    if (props.location.search == "")
    {
        global.window && (global.window.location.href = window.location.origin + props.location.pathname + "?password");
        return;
    }

    const checkPw = () =>
    {
        const answer = document.getElementById("password").value;
        if (answer === "test")
        {
            setIsVerified(true);
        }
    };
    return (
        <div>
            <Helmet>
                <title>[P] eFX/FX | Lucas RODRIGUEZ</title>
            </Helmet>
            <p><i className="fa fa-home"></i>&nbsp; <NavLink to="/">Lucas RODRIGUEZ's home</NavLink> &bull; <NavLink to="/perso">[P] Home</NavLink></p>

            <div className="p-1 mb-2 bg-danger text-white text-center bg-opacity-80">
                <b>CONFIDENTIAL/PROTECTED</b>
            </div>

            <hr />

            <h2 class="mb-4">eFX/FX resources</h2>

            <p>Useful resources on (electronic) FX trading, technology, ...</p>

            <hr class="col-3 col-md-2 mb-5" />


            {!isVerified ?
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                        <form onSubmit={checkPw}>
                            <div class="form-group mb-3">
                                <input class="form-control" id="password" name="password" type="password" placeholder="Password" autoFocus />
                            </div>
                            {/*<div class="form-group">
                                <input class="form-control" id="password2" name="password2" type="password" placeholder="Password 2" />
                            </div>*/}
                            <button class="btn btn-dark btn-block mt-3" style={{ width: "100%" }}><span class="fa fa-lock"></span>&nbsp;&nbsp;Authenticate</button>
                            {/*<button class="btn btn-danger btn-block mt-2" style={{ width: "100%" }}>SSO/PA</button>*/}
                        </form>
                    </div>
                </div>
                :
                <div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-header">
                                    <span className="badge bg-success">1</span>
                                </div>

                                <div class="card-body">
                                    <h5 class="card-title">FX</h5>
                                    <h6 class="card-subtitle mb-2 text-body-secondary"></h6>
                                    <p class="card-text">FX Options, forwards, swaps</p>
                                    <a href="https://github.com/lcsrodriguez/efx-resources" target="_BLANK" role="button" class="btn btn-warning">Resources (GitHub)</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-header">
                                    <span className="badge bg-primary">2</span>
                                </div>

                                <div class="card-body">
                                    <h5 class="card-title">eFX</h5>
                                    <p class="card-text">
                                        <ol>
                                            <li><a href="https://google.com" target="_BLANK">eFX</a></li>
                                            <li><a href="https://google.com" target="_BLANK">eFX</a></li>
                                            <li><a href="https://google.com" target="_BLANK">eFX</a></li>
                                            <li><a href="https://google.com" target="_BLANK">eFX</a></li>
                                        </ol>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-header">
                                    <span className="badge bg-danger">3</span>
                                </div>

                                <div class="card-body">
                                    <h5 class="card-title">Technology</h5>
                                    <h6 class="card-subtitle mb-2 text-body-secondary"></h6>
                                    <p class="card-text">FX Options, forwards, swaps</p>
                                    <a href="https://github.com/lcsrodriguez/efx-resources" target="_BLANK" role="button" class="btn btn-warning">Resources (GitHub)</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-header">
                                    <span className="badge bg-info">4</span>
                                </div>

                                <div class="card-body">
                                    <h5 class="card-title">Network/DMA/ULLDMA</h5>
                                    <p class="card-text">
                                        <ol>
                                            <li><a href="https://google.com" target="_BLANK">eFX</a></li>
                                            <li><a href="https://google.com" target="_BLANK">eFX</a></li>
                                        </ol>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <hr class="mt-5" />

            <div className="p-1 mb-2 bg-danger text-white text-center bg-opacity-80">
                <b>CONFIDENTIAL/PROTECTED</b>
            </div>
        </div >
    );
}
export default FX;